module.exports = __webpack_public_path__ + "img/ga.66d71027.svg";